(async function () {
  const Useful = await waitForLayer();
  const { isEmail } = Useful.libs["@useful/helpers"];
  const { useFlow } = Useful.libs["@useful/components"];
  const { defineApp, register } = Useful.api.components;
  const { setItem, getItem } = Useful.api.storage;

  let app_tag_name = "u-marketing-capture-app";
  let app_cookie_key = "u-marketing-capture-hidden";

  const list_id = window.location.host.includes("jjimjil.com")
    ? "TxeZtp"
    : "Rp8JDL";

  const klaviyo_web_api_client = (function () {
    class KlaviyoWebApiClient {
      constructor(public_key, revision_v = "2024-02-15") {
        if (!public_key) throw "[klaviyo_web_api] Public Key is required";
        this.public_key = public_key;
        this.revision_v = revision_v;
        this.send = this.send.bind(this);
      }
    }

    KlaviyoWebApiClient.prototype.send = async function (
      pathname,
      body = null,
      options = {}
    ) {
      try {
        const r = await fetch(
          `https://a.klaviyo.com/client${pathname}?company_id=${this.public_key}`,
          {
            method: options.method || "POST",
            headers: {
              "Content-Type": "application/json",
              revision: this.revision_v,
              ...(options.headers || {}),
            },
            body: body !== null ? JSON.stringify(body) : null,
          }
        );

        const d = await r.text();
        if (r.status < 200 || r.status > 299) throw JSON.parse(d);

        return { data: "success" };
      } catch (error) {
        return { error };
      }
    };

    return new KlaviyoWebApiClient("SCzzQE");
  })();

  async function klaviyoSubscribeToList(
    list_id,
    klv_profile,
    additional_options = {}
  ) {
    if (!list_id) throw "Missing list_id";
    if (typeof klv_profile !== "object") throw "Missing KlaviyoWebApiProfile";

    return klaviyo_web_api_client.send("/subscriptions", {
      data: {
        type: "subscription",
        attributes: {
          custom_source: additional_options.source,
          profile: {
            data: {
              type: "profile",
              id: klv_profile.klaviyo_profile_id,
              attributes: {
                ...klv_profile,
              },
              meta: klv_profile.meta,
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: list_id,
            },
          },
        },
      },
    });
  }

  async function klaviyoUpdateProfile(klv_profile) {
    if (typeof klv_profile !== "object") throw "Missing KlaviyoWebApiProfile";

    return klaviyo_web_api_client.send("/profiles", {
      data: {
        type: "profile",
        attributes: {
          ...klv_profile,
        },
        meta: klv_profile.meta,
      },
    });
  }

  register(
    app_tag_name,
    defineApp({
      name: "UMarketingCaptureApp",
      props: {
        "email-list-id": {
          reflect: false,
          default: null,
        },
        "email-platform": {
          default: "klaviyo",
        },
        closeable: {
          default: false,
        },
      },
      attrs: {
        "required-fields": {
          default: ["email"],
        },
        source: {
          type: "string",
          default: "Website",
        },
      },
      setup(_props, { slots, vue_lib, attrs }) {
        const { defineComponent, reactive, ref, computed } = vue_lib;
        const is_hidden = ref(true);
        getItem("cookie", app_cookie_key).then((v) => {
          is_hidden.value = v ? true : false;
        });
        function hide() {
          is_hidden.value = true;
          setItem("cookie", app_cookie_key, true, {
            ttl: 1 * 60 * 60 * 1000,
          });
        }


        if (attrs.class?.includes("floating-capture")) {
          window.toggleMarketingCapture = function (value) {
            is_hidden.value = value;
          };
        }

        const flow = useFlow(
          { reactive, computed },
          {
            name: "MarketingCaptureFlow",
            translations: {
              EMAIL_REQUIRED: "Email required",
              VALID_EMAIL_REQUIRED: "Valid email required.",
            },
            steps: [
              {
                name: "EmailStep",
                inputs: [
                  {
                    name: "EmailInput",
                    data_path: "email",
                    rules: [
                      async function (value) {
                        if (!value) throw "EMAIL_REQUIRED";
                        if (!isEmail(value)) throw "VALID_EMAIL_REQUIRED";
                        const { error } = await klaviyoSubscribeToList(
                          list_id,
                          {
                            email: value,
                          },
                          {
                            source: attrs.source,
                          }
                        );
                        if (error) throw error;
                        return true;
                      },
                    ],
                    template: slots["email-input"],
                  },
                ],
                template: slots["email-step"],
              },
            ],
          }
        );

        const step_components = flow.steps.map((step) => {
          let { template, ...step_setup } = step;
          return defineComponent({
            name: step_setup.name,
            setup() {
              step_setup.inputs = step_setup.inputs.map((input) => {
                let template = input.template;
                delete input.template;
                return Object.assign(input, {
                  component: defineComponent({
                    name: input.name,
                    setup() {
                      return Object.assign(input, { step });
                    },
                    template,
                  }),
                });
              });
              return Object.assign(step_setup, { hide });
            },
            template,
          });
        });

        const reward_component = defineComponent({
          name: "Reward",
          setup() {
            setItem("cookie", app_cookie_key, true, {
              ttl: 1 * 60 * 60 * 1000,
            });
            return {
              hide,
            };
          },
          template: slots["reward-step"],
        });

        const current_step = computed(() => {
          return (
            step_components[flow.stepper.current_index] || reward_component
          );
        });

        return {
          flow,
          current_step,
          is_hidden,
        };
      },
    })
  );
})();
